module.exports = __webpack_public_path__ + "static/media/bg-section-05.5623670b.png";